import React from 'react';
import {Typography} from '@mui/material';
import {getTagColor, tagChipStyles} from './tagColors';

/**
 * Visual tag chip used by the TAGS block ({@link TagChip}) and shared-tag surfaces
 * (Tag browse header, /icr tag filter). Always shows the "# " prefix.
 */
export default function TagBadge({
    tag,
    voted = true,
    voteCount = null,
    sx,
    ...typographyProps
}) {
    const hex = getTagColor(typeof tag === 'string' ? {name: tag} : tag);
    const styles = tagChipStyles(hex, voted);
    const name = typeof tag === 'string' ? tag : (tag?.name || '');

    return (
        <Typography
            component="span"
            p="3px 8px 4px"
            bgcolor={styles.bgcolor}
            color={styles.color}
            outline={styles.outline}
            variant="body2"
            borderRadius="12px"
            sx={sx}
            {...typographyProps}
        >
            # {name}{voteCount != null ? ` (${voteCount})` : ''}
        </Typography>
    );
}
